export const grossFeeTooltip = {
  cpm: 'Bid CPM is reduced by the partner fixed CPM fee (i.e. $1.50 CPM and a $0.50 fixed CPM fee results in a $1 bid and a $0.50 partner fee).',
  pom: 'Bid CPM is reduced by partner fee % (i.e. $1 CPM bid with 10% fee results in a $0.90 bid & 0.10 partner fee).',
} as const;

export const netFeeTooltip = {
  cpm: 'Partner fixed CPM fee net of OpenX platform fee applied.',
  pom: 'Partner fee % net of OpenX platform fee applied.',
} as const;
